import {TranslationObject} from '@colonist/i18n'
import {ColonistMembershipPerk, ColonistMembershipProduct, PerkNoAds} from '../../../../shared/store/ColonistMembershipProduct'
import {UIStoreMembershipProductView} from '../../../shared/scripts/store/UIStoreMembershipProductView'
import {UIPopupController} from '../../../shared/scripts/ui_popup/UIPopupController'
import {DiscordInstance} from '../discord/DiscordInstance'
import {SDKRequest} from '../../../../shared/DiscordActivityTypes'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {UIStoreState} from '../../../shared/scripts/store/UIStoreState'
import {createParagraphIn, setElementInnerHTML} from '../../../shared/scripts/ui_utils/DomUtils'
import {getManageSubscriptionPopupBody} from '../../../shared/scripts/store/StoreUtils'
import {DiscordAnnualMembershipPrices} from '../../../../shared/store/StoreConstants'
import {UIStoreGiftOverlayController} from '../../../shared/scripts/store/gift/UIStoreGiftOverlayController'
import {UIMembershipProductView} from '../../../shared/scripts/store/UIMembershipProductView'
import {ColonistMembershipType} from '@colonist/types'

export class UIDStoreMembershipProductView extends UIStoreMembershipProductView {
    constructor(container: HTMLDivElement, storeState: UIStoreState, membershipProduct: ColonistMembershipProduct, giftOverlay?: UIStoreGiftOverlayController) {
        super(container, storeState, membershipProduct, giftOverlay)

        if(this.membershipProduct.billedAnnually) this.setAnnualMembershipPriceText()
    }

    protected override sendToCheckout() {
        if(UIUtilsEjsVariables.isUserOnDiscordMobile) {
            UIDStoreMembershipProductView.showUnavailableOnMobilePopup()
            return
        }
        void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseMembership, this.membershipProduct.type)
    }

    // eslint-disable-next-line class-methods-use-this
    protected override getValidMembershipPerks(membership: ColonistMembershipProduct): ColonistMembershipPerk[] {
        const membershipPerks = super.getValidMembershipPerks(membership)
        const perksToFilter = [new PerkNoAds()]

        const validPerks = membershipPerks.filter((perk: ColonistMembershipPerk) => !perksToFilter.some((perkToFilter: ColonistMembershipPerk) => perk.type === perkToFilter.type))

        UIMembershipProductView.mergeMapsAndExpansionDescriptions(validPerks)
        return validPerks
    }

    protected override getDisclaimerKey(): TranslationObject {
        const yearlyPrice = this.getAnnualMembershipPrice()
        if(yearlyPrice == undefined) return {key: 'strings:storePage.sections.membership.billing.monthly'}

        if(this.membershipProduct.billedAnnually) return {key: 'strings:storePage.sections.membership.billing.annually', options: {context: 'nonRenewing', amount: `${yearlyPrice / 100}`}}

        return {key: 'strings:storePage.sections.membership.billing.monthly'}
    }

    private setAnnualMembershipPriceText() {
        const yearlyPrice = this.getAnnualMembershipPrice()
        if(yearlyPrice == undefined) return
        const monthlyPrice = (yearlyPrice / 100) / 12
        const roundedMonthlyPrice = monthlyPrice.toFixed(2)

        setElementInnerHTML(this.priceDiv, {key: 'strings:colonistCommon.utils.emptyString'})

        this.membershipPrice = createParagraphIn(this.priceDiv, {key: 'strings:storePage.sections.membership.billing.paidMonthly', options: {context: 'biggerPrice', amount: `${roundedMonthlyPrice}`, currency: '$'}}, '', '')

        const shouldShowStrikethroughPrice = this.membershipProduct.billedAnnually
        if(!shouldShowStrikethroughPrice) return

        this.showStrikeThroughPrice()
    }

    // eslint-disable-next-line class-methods-use-this
    protected override manageSubscription() {
        UIDStoreMembershipProductView.createManageSubscriptionPopup()
    }

    private static createManageSubscriptionPopup() {
        const popupTitle: TranslationObject = {key: 'strings:storePage.manageMembership.title'}
        const popupBody: TranslationObject = getManageSubscriptionPopupBody()
        UIPopupController.createSimplePopup(popupTitle, popupBody)
    }

    private static showUnavailableOnMobilePopup() {
        const popupTitle: TranslationObject = {key: 'strings:popups.unavailableOnMobile.title'}
        const popupBody: TranslationObject = {key: 'strings:popups.unavailableOnMobile.body'}
        UIPopupController.createSimplePopup(popupTitle, popupBody)
    }

    private getAnnualMembershipPrice(): number | undefined {
        switch(this.membershipProduct.type) {
            case ColonistMembershipType.PlusYearly: return DiscordAnnualMembershipPrices.PLUS
            case ColonistMembershipType.PremiumYearly: return DiscordAnnualMembershipPrices.PREMIUM
            case ColonistMembershipType.EliteYearly: return DiscordAnnualMembershipPrices.ELITE
            default: return undefined
        }
    }
}
